const scroll = () => {
  const speed = 500;
  const offsetNum = 100;

  /**
   * smooth scrolls to #id on page
   * @returns {scroll} smooth scrolls to id on page and takes into consideration offset
   */
  function handleSmoothScroll() {
    if (window.innerWidth < 780) {
      event.preventDefault();
      const finalOffset = $(this.hash).offset().top - offsetNum;
      $('html,body').animate({ scrollTop: finalOffset }, speed);
    }
  }

  $('.faq-navigation a[href*=\\#]').on('click', handleSmoothScroll);
};

export { scroll };



// WEBPACK FOOTER //
// ./partial-scripts/smoothScroll.js